import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const Container = styled.section`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;

    ${MediaQuery.medium(css`
        row-gap: 32px;
    `)};

    ${MediaQuery.xLarge(css`
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        align-items: end;
    `)}; 
`;

export const ReferencesList = styled.div`
    display: grid;
    grid-template-columns: max-content max-content;
    row-gap: 24px;
    column-gap: 16px;

    ${MediaQuery.medium(css`
        grid-template-columns: repeat(4, max-content);
        column-gap: 64px;
    `)};
`;

export const ReferenceItem = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 4px; 
`;

export const ReferenceLabel = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${colors.BLACK};
`;

export const ReferenceValue = styled.p`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 18px;
    `)};
`;

export const TotalItem = styled.div`
    padding: 12px 0;
    display: flex;
    justify-content: center;
    background-color: #FFEFE8;
    border-radius: 4px;
    gap: 8px;
    align-items: center;

    ${MediaQuery.medium(css`
        padding: 12px 24px;
    `)};
`;

export const TotalItemLabel = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
`;

export const TotalItemValue = styled.p`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    text-transform: lowercase;

    ${MediaQuery.medium(css`
        font-size: 18px;
    `)};
`;

export const TotalsList = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;

    ${MediaQuery.medium(css`
        grid-auto-flow: column;
        grid-auto-columns: max-content;
        column-gap: 8px;
    `)};

    ${MediaQuery.xLarge(css`
        justify-self: end;
    `)};
`;
